import React from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../components/Logo'

export default function PrivacyPage() {
  const navigate = useNavigate()
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text1)' }}>
      <nav style={{ height: 52, background: 'var(--surface)', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', padding: '0 20px', gap: 10, position: 'sticky', top: 0, zIndex: 10 }}>
        <div style={{ cursor: 'pointer' }} onClick={() => navigate('/')}><Logo /></div>
      </nav>
      <div style={{ maxWidth: 640, margin: '0 auto', padding: '48px 24px' }}>
        <h1 style={{ fontFamily: 'Sora, sans-serif', fontSize: 24, fontWeight: 700, letterSpacing: -0.5, marginBottom: 4 }}>Privacy Policy</h1>
        <p style={{ fontSize: 13, color: 'var(--text3)', marginBottom: 32 }}>Last updated: April 16, 2026</p>

        <Section title="What we collect">
          When you accept cookies, we collect anonymous usage data via Google Analytics 4 — pages visited, session duration, and general location (country level). We do not collect personal information through cookies.
        </Section>

        <Section title="What we don't do">
          We never sell your data. We never use advertising cookies. We never share your data with third parties except Google Analytics for usage measurement.
        </Section>

        <Section title="Your data in Skilflow">
          Your account information, skills, and team content are stored securely in our database and never shared with other organizations.
        </Section>

        <Section title="Cookie storage">
          We store your cookie preference in your browser's localStorage. You can clear this at any time by clearing your browser data.
        </Section>

        <Section title="Contact">
          Questions? Email <a href="mailto:hello@skilflow.ai" style={{ color: 'var(--brand-light)', textDecoration: 'none' }}>hello@skilflow.ai</a>
        </Section>
      </div>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>{title}</h2>
      <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.7 }}>{children}</p>
    </div>
  )
}
